import PropTypes from 'prop-types';
import {useState} from 'react';

import {PSR_TYPES} from '../../../constants/typesMessages';
import {useGetProductsCnae} from '../../../hooks/useGetProductsCnae';
import {getPsrs} from '../../../services/Api';
import {generateFiservAliancaPsrs, generateStoneTonPsrs} from '../../../services/psrAlianca';
import {generateiFoodPsr} from '../../../services/iFoodPsr';
import {
  getStringWithPsrAcceptedByCnae,
  psrDefineGroupTypes,
  sendMessageGetFirstPsrTypeSelected
} from '../../../services/psr';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';
import {usePsrStore} from '../../../store/slices/psrStore';
import './MessagePsrsTypeQuestion.style.scss';

export const MessagePsrsTypeQuestion = (props) => {
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const setPsrGroupType = usePsrStore((state) => state.setPsrGroupType);
  const setPsrPaymentType = usePsrStore((state) => state.setPsrPaymentType);
  const setPsrsGroupShow = usePsrStore((state) => state.setPsrsGroupShow);
  const [ecommerce, setEcommerce] = useState(false);
  const [physical, setPhysical] = useState(false);
  const [questions, setQuestions] = useState(true);

  // Garante que produtos sejam carregados antes de buscar PSRs
  useGetProductsCnae();

  const getPsrsGroup = () => {
    const currentProducts = useInteractionStore.getState().productsCnae;

    if (!currentProducts?.length) {
      console.error('[MessagePsrsTypeQuestion] productsCnae is empty');
      setDotTyping(false);
      responseTypeChange(PSR_TYPES.PSR_ERROR);
      return;
    }

    const productsGroup = getStringWithPsrAcceptedByCnae(currentProducts);

    if (!productsGroup) {
      console.error('[MessagePsrsTypeQuestion] productsGroup is empty');
      setDotTyping(false);
      responseTypeChange(PSR_TYPES.PSR_ERROR);
      return;
    }

    getPsrs(productsGroup)
      .then((res) => {
        const psrsWithIFood = generateiFoodPsr(res.data);
        const psrsWithFiserv = generateFiservAliancaPsrs(psrsWithIFood);
        const psrsWithStone = generateStoneTonPsrs(psrsWithFiserv);

        setPsrsGroupShow(psrsWithStone);
        setPsrGroupType(psrDefineGroupTypes(psrsWithStone));

        sendMessage(sendMessageGetFirstPsrTypeSelected(physical));
        setDotTyping(false);
      })
      .catch((error) => {
        console.error('[MessagePsrsTypeQuestion] API Error:', error);
        setDotTyping(false);
        responseTypeChange(PSR_TYPES.PSR_ERROR);
      });
  };

  const saveOptions = () => {
    const selectedOptions = [];

    if (physical)
      selectedOptions.push('Maquininhas para pagamentos presenciais');
    if (ecommerce) selectedOptions.push('Maquininhas para pagamentos online');

    setQuestions(false);
    setPsrPaymentType({ecommerce, physical});

    sendMessage({
      text: selectedOptions.join(', '),
      type: 'send-message'
    });

    setDotTyping(true);
    getPsrsGroup();
  };

  return (
    <>
      <div
        className="message-line"
        id="message-select-type"
        data-testid="message-select-type"
      >
        <div className="message-receive" id={`msg-${props.question.id}`}>
          <div className="message-div" data-aut-test="message-receive-text">
            <p>
              OK! Escolha o tipo de maquininha que melhor atende ao seu
              negócio.{' '}
            </p>
            <ul>
              <li>
                <p>
                  <strong>Maquininhas para Pagamentos Presenciais:</strong>
                </p>
                <p className="message-psr__line">
                  Essas são as mais conhecidas, usadas no dia a dia para vendas
                  presenciais. Aceitam cartões físicos e pagamentos por
                  aproximação com o celular.
                </p>
              </li>
              <li>
                <strong>Maquininhas para Pagamentos Online:</strong>
                <p />
                <p className="message-psr__line">
                  São sistemas ou aplicativos que permitem a realização de
                  pagamentos eletrônicos, como em apps de delivery ou no site do
                  seu estabelecimento (E-Commerce).
                </p>
              </li>
            </ul>
            <p>Por favor, selecione uma ou as duas opções abaixo: </p>
          </div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <>
          {questions && (
            <div className="message-line">
              <div className="div-button-psr-payments-type">
                <button
                  name="physical-payments"
                  data-testid="physical-payments"
                  onClick={() => setPhysical(!physical)}
                  className={physical ? 'btn-psr-type-selected' : ''}
                >
                  MAQUININHAS PARA PAGAMENTOS PRESENCIAIS
                </button>
                <button
                  name="ecommerce-payments"
                  data-testid="ecommerce-payments"
                  onClick={() => setEcommerce(!ecommerce)}
                  className={ecommerce ? 'btn-psr-type-selected' : ''}
                >
                  MAQUININHAS PARA PAGAMENTOS ONLINE
                </button>
                {(physical || ecommerce) && (
                  <div>
                    <button
                      className="btn-psr-payment-option-save-type"
                      data-testid="btn-psr-payment-option-save"
                      onClick={saveOptions}
                    >
                      Salvar
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      </HideButtonWhenLogout>
    </>
  );
};

MessagePsrsTypeQuestion.propTypes = {
  question: PropTypes.object
};
